import { render, staticRenderFns } from "./LegalConsent.vue?vue&type=template&id=7d2e7901&scoped=true&"
import script from "./LegalConsent.vue?vue&type=script&lang=js&"
export * from "./LegalConsent.vue?vue&type=script&lang=js&"
import style0 from "./LegalConsent.vue?vue&type=style&index=0&id=7d2e7901&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d2e7901",
  null
  
)

export default component.exports